import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import { MouseEventHandler, memo, useCallback } from "react";
import { useDispatch } from "react-redux";

import { IconButton } from "@tsp/tsp-frontend-components/mui";

import { useNotifierApi } from "../../../../hooks";
import { NotificationData } from "../../../../types";

type NotificationProps = {
  notification: NotificationData;
};

function Notification(props: NotificationProps) {
  const { notification } = props;

  const dispatch = useDispatch();
  const [showNotification, hideNotification] = useNotifierApi();

  const onClickCloseHandler = useCallback<MouseEventHandler<HTMLElement>>(
    (event) => {
      hideNotification(event.currentTarget.dataset.uuid);
    },
    [hideNotification],
  );

  const action = notification.isManual ? (
    <IconButton size="small" color="inherit" data-uuid={notification.uuid} onClick={onClickCloseHandler}>
      <CloseIcon fontSize="inherit" />
    </IconButton>
  ) : null;

  return (
    <Alert action={action} severity={notification.type}>
      {notification.message}
    </Alert>
  );
}

const Wrapper = memo(Notification);

export { Wrapper as Notification };
